// extracted by mini-css-extract-plugin
export default {"obsItem":"obsItem__okZkz","detailLabel":"detailLabel__Lc3l1","detailLabel-button":"detailLabel-button__itATu","type":"type__uDybD","popoverType":"popoverType__HJry5"};